import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

export const adgptTokenBalanceValidator = zod.object({
    tokensAvailable: zod.number().int().nonnegative(),
    updatedAt: iso8601DateTimeZodValidator,
    updatedBy: uuidZodValidator,
    userId: uuidZodValidator,
});

export type AdgptTokenBalance = {
    tokensAvailable: number;
    updatedAt: Iso8601DateTime;
    updatedBy: Uuid;
    userId: Uuid;
};

export const adgptTokenLedgerEntryValidator = zod.object({
    createdAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    id: uuidZodValidator,
    remark: zod.string().nullable(),
    tokenDelta: zod.number().int(),
    transactionType: uuidZodValidator,
    usageId: zod.string().nullable(),
    userId: uuidZodValidator,
});

export type AdgptTokenLedgerEntry = zod.infer<typeof adgptTokenLedgerEntryValidator>;

export const ADGPT_ADMIN_CREDIT_TRANSACTION_TYPE = "88bc752e-d5fa-4782-b116-ed0b64a46f6c";
export const ADGPT_USAGE_DEBIT_TRANSACTION_TYPE = "63701de0-1e2a-4008-92fb-614f4a9328a2";

export function adgptTokenTransactionTypeLabel(transactionType: string): string {
    if (transactionType === ADGPT_ADMIN_CREDIT_TRANSACTION_TYPE) {
        return "Admin credit";
    }
    if (transactionType === ADGPT_USAGE_DEBIT_TRANSACTION_TYPE) {
        return "Usage debit";
    }
    return "Unknown";
}

export const adgptTokenUsageLeaderboardEntryValidator = zod.object({
    rank: zod.number().int().positive(),
    tokensUsed: zod.number().int().nonnegative(),
    userId: uuidZodValidator,
    userName: zod.string().nullable(),
});

export type AdgptTokenUsageLeaderboardEntry = zod.infer<typeof adgptTokenUsageLeaderboardEntryValidator>;

export const adgptTokenAddOutcomeValidator = zod.discriminatedUnion("status", [
    zod.object({
        balance: adgptTokenBalanceValidator,
        ledgerEntry: zod.unknown(),
        status: zod.literal("added"),
    }),
    zod.object({status: zod.literal("balance_not_found")}),
]);
